import isAfter from 'date-fns/isAfter'
import isBefore from 'date-fns/isBefore'
import isEqual from 'date-fns/isEqual'
import addDays from 'date-fns/addDays'
import format from 'date-fns/format'
import eachMinuteOfInterval from 'date-fns/eachMinuteOfInterval'
import parse from 'date-fns/parse'
import parseJson from 'parse-json'
import { TIME_SLICE } from 'src/utils/constant'
import { parseValid } from 'src/utils'

export const getDaySegment = (time) => {
  let segment = 0
  const afternoonDate = parseValid('13:30', TIME_SLICE, new Date())
  const eveningDate = parseValid('17:30', TIME_SLICE, new Date())

  switch (true) {
    case isEqual(time, afternoonDate) || (isAfter(time, afternoonDate) && isBefore(time, eveningDate)):
      segment = 1
      break
    case isEqual(time, eveningDate) || isAfter(time, eveningDate):
      segment = 2
      break
    default:
      break
  }

  return segment
}

export const getTimeSlices = (string) => {
  const startTimeString = string.split('-')[0]
  const endTimeString = string.split('-')[1]
  const startTime = parse(startTimeString === '24:00' ? '00:00' : startTimeString, TIME_SLICE, new Date())
  const endTime = parse(endTimeString === '24:00' ? '00:00' : endTimeString, TIME_SLICE, new Date())

  // 按照30分钟切割获得时间数组
  const timeSlices = eachMinuteOfInterval(
    // 当startTime >= endTime，认为endTime已经跨天，需加一天计算
    { start: startTime, end: endTime.getTime() <= startTime.getTime() ? addDays(endTime, 1) : endTime },
    { step: 30 },
  )

  // 切割后的时间数组就行格式化处理并剔除末尾项
  const finalTimeSlices = timeSlices
    .map((time, index) => {
      const start = format(time, TIME_SLICE)
      const end = timeSlices[index + 1] ? format(timeSlices[index + 1], TIME_SLICE) : ''
      return { label: `${start}-${end}`, value: format(time, TIME_SLICE), daySegment: getDaySegment(time) }
    })
    .slice(0, timeSlices.length - 1)

  return finalTimeSlices || []
}

export const getFormatAvlObj = (avlDoctorInfo, avlClinicInfo) => {
  // 获取对应星期几可预约时间点数组
  const formatAvlObj = {}
  // 医生上班时间
  let availableObj = null
  try {
    availableObj = parseJson(avlDoctorInfo?.available) || {}
  } catch (error) {
    availableObj = {}
  }

  // 诊所上班时间
  let testCenterAvailableObj = null
  try {
    testCenterAvailableObj = parseJson(avlClinicInfo?.availableTime)
  } catch (error) {
    testCenterAvailableObj = {}
  }

  for (const availableDay of Object.keys(availableObj)) {
    let availableTimeSlices = []
    let testCenterAvailableTimeSlices = []
    const availableTimeArray = availableObj[availableDay]
    const testCenterAvailableTimeArray = testCenterAvailableObj[availableDay]
    if (!testCenterAvailableTimeArray) continue
    availableTimeArray?.forEach((availableTime) => {
      availableTimeSlices = availableTimeSlices.concat(getTimeSlices(availableTime))
    })
    testCenterAvailableTimeArray?.forEach((availableTime) => {
      testCenterAvailableTimeSlices = testCenterAvailableTimeSlices.concat(getTimeSlices(availableTime))
    })
    formatAvlObj[availableDay] = availableTimeSlices?.filter((doctorSlice) =>
      testCenterAvailableTimeSlices?.find((clinicSlice) => clinicSlice.value === doctorSlice.value),
    )
  }
  return formatAvlObj
}
